import React from 'react';
import { motion } from 'framer-motion';
import { cvData } from '../data/cvData';
import { uiTranslations } from '../data/translations';
import { useLanguage } from '../context/LanguageContext';
import SectionHeader from './SectionHeader';

export default function Personal() {
  const { language } = useLanguage();
  const data = cvData[language];
  const t = uiTranslations[language].sections.personal;

  if (!data.personal_text) return null;

  return (
    <section id="personal" className="py-24 bg-white border-t border-slate-50">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <SectionHeader title={t.title} label={t.label} />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-start">
          <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="md:col-span-1">
            <div className="relative aspect-square rounded-2xl overflow-hidden bg-slate-100 border border-slate-200 shadow-sm group">
              <img src="https://media-manager-c.questera.ai/greta-media/7e4a9c767f1b6bc32d9ae74da3c793a469ade620e650261cdbc16bd121baf63aa043e6e0cde1a6fa76e813042dd40456/images/aW1hZ2UvanBlZw==/474145184305aff3f142404bd660b2c9.jpg" alt="Familie Schmitt" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/10 to-transparent"></div>
            </div>
          </motion.div>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="md:col-span-2">
            <div className="space-y-6 max-w-3xl">
              {data.personal_text.split('\n\n').map((paragraph, index) => (
                <p key={index} className="text-lg text-slate-600 leading-relaxed font-light">
                  {paragraph}
                </p>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}